import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';
import { LinearProgress } from '@mui/material';
import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

import { MenuOrientation } from 'types/config';
import { useGetProjectQuery } from 'store/userOrg/enhancedUserOrgApi';
import GlobalFilter from './globalFilter';

const HeaderContent = () => {
    const { menuOrientation } = useConfig();
    const { data: projects, isLoading: projectsIsLoading } = useGetProjectQuery({});

    const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    return (
        <>
            <Box marginLeft={10}> {projectsIsLoading ? <LinearProgress /> : <GlobalFilter projects={projects} />}</Box>
            {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
            {!downLG && <Search />}
            {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

            {!downLG && <Profile />}
            {downLG && <MobileSection />}
        </>
    );
};

export default HeaderContent;
